<template>
    <div class="field__multi" ref="parent">
        <ul
            class="field__multi__options__content"
            :class="{ 'field__scroll scroll': filterFields.length > 5 }"
        >
            <li
                v-for="( field, index) in filterFields"
                class="field__multi__option field__drop__option pointer"
                :class="{ 'js--active': index ===  selectedOption }"
                :key="index"
            >
                <input
                    type="checkbox"
                    :name="`option-${name}${index}`"
                    :id="`option-${name}${index}`"
                    v-model="options"
                    :value="field.value"
                    class="field__checkbox__input display--none"
                    v-bind="{
                        ...( !allowFilling && { disabled: 'disabled' })
                    }"
                />
                <label :for="`option-${name}${index}`"
                    :class="[
                        'field__checkbox position--relative display--block',
                        { 'pointer': allowFilling }
                    ]"
                >
                    <span
                        :class="[
                            'field__checkbox__icon display--inline-b position--absolute background--grey--light'
                        ]"
                        aria-hidden="true"
                        :aria-label="$t('accessibility.arrow')"></span>
                    {{ field.label }}
                </label>
            </li>
        </ul>
    </div>
</template>

<script>
// packages
import { reactive, toRefs, watch } from '@vue/composition-api';

// hooks
import { baseProps, behavior } from '@/hooks/use-drop';
import { reset } from '@/hooks/use-input-listeners';

// utils
import { compareTwoArrays } from '@/utils/';

export default {
    inheritAttrs: false,
    props: {
        ...baseProps,
        defaultValue: Array,
        name: [ Number, String ],
        reset: Boolean,
        isEditPage: Boolean,
        isCampaignList: Boolean,
        allowFilling: {
            type: Boolean,
            default: true
        }
    },
    setup ( props, { emit }) {
        const state = reactive({
            parent: null,
            fields: props.data,
            options: [],
            selectedOption: -1
        });
        // listener para quando for necessário
        // proceder a um reset a input.
        reset({ props, object: state, key: 'options' });

        // definição das opções já selecionadas
        watch( () => props.defaultValue,
            newdefaultValue => {
                // só actualiza as opções, quando o array proveniente da API
                // é diferente do que já esta selecionado pelo utilizador.

                if ( !compareTwoArrays( state.options, newdefaultValue ) && !props.isCampaignList )
                    state.options = newdefaultValue;
            }, {
                immediate: true
            });

        // emissão das opções selecionadas.
        watch( () => state.options,
            newOptions => {
                // caso o array fique vazio, é necessário apagar
                // na store.
                const value = newOptions.length || props.isEditPage ? newOptions : '';
                emit( 'input', value );
            });

        return {
            ...toRefs( state ),
            ...behavior( props, state )
        };
    }
};
</script>